import { Flex } from "@mantine/core";
import { SystemProp } from "@mantine/styles/lib/theme/types/MantineStyleSystem";
import { CSSProperties } from "react";

import ActionIcon from "../ActionIcon/ActionIcon";
import SvgInfo from "../Icons/Info";
import { useStyles } from "./NoDataMessage.styles";

interface Props {
  minWidth?: CSSProperties["minWidth"];
  h?: SystemProp<CSSProperties["height"]>;
}

export default function NoDataMessage({ minWidth, h }: Props) {
  const { classes } = useStyles({ minWidth });
  return (
    <Flex className={classes.empty} h={h}>
      <ActionIcon variant="ghost" size={48}>
        <SvgInfo />
      </ActionIcon>
      <span>No data to display.</span>
    </Flex>
  );
}
